import { z } from "zod";
import { KycSchema, PreReviewDocumentSchema, UserSchema } from "../treezor/index.js";
import getTreezorAccountCreatorKycLiveness from "./getTreezorAccountCreatorKycLiveness.js";

export default {
  params: z.object({
    memberInvitationId: z.string(),
  }),
  response: getTreezorAccountCreatorKycLiveness.response.extend({
    user: UserSchema.extend({ kyc: KycSchema.optional() }),
    powerOfAttorneyRequired: z.boolean(),
    powerOfAttorneyDocument: PreReviewDocumentSchema.nullable(),
  }),
};
